import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import api from "../core/api";

export default function GuestGuard({ children }) {
  const [status, setStatus] = useState("loading");
  const [retryKey] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function checkAuth() {
      const token = localStorage.getItem("token");

      if (!token) {
        if (!cancelled) setStatus("guest");
        return;
      }

      try {
        const res = await api.get("/auth/me");
        const data = res.data;
        const userData = data?.user || data;

        if (userData && data?.success !== false) {
          localStorage.setItem("user", JSON.stringify(userData));
          if (!cancelled) setStatus("authed");
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          if (!cancelled) setStatus("guest");
        }
      } catch (err) {
        if (!err.response) {
          console.warn("Network error while checking auth:", err);
          if (!cancelled) setStatus("guest");
          return;
        }

        const httpStatus = err.response.status;

        if (httpStatus === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          if (!cancelled) setStatus("guest");
          return;
        }

        console.warn("Server responded with error:", httpStatus);
        if (!cancelled) setStatus("guest");
      }
    }

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, [retryKey]);

  if (status === "loading") {
    return <LoadingScreen message="در حال بررسی وضعیت ورود..." />;
  }

  if (status === "authed") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
